export const range = (value: number) => {
  let arr = [];
  for (let i = 0; i < value; i++) {
    arr.push(i);
  }
  return arr;
};
